<div [class.dark-theme]="true" class="fix-action-dialog2 contact_dialog" style="background-color: #24242480;margin:12px;font-weight: bold;">
	<h3 mat-dialog-title style="padding:16px; color: #ffffff;">
		<mat-icon>mail</mat-icon><span style="padding-left: 12px;font-size: 23px;font-weight: bold;letter-spacing: 0.2em;">{{content.title}}</span></h3>
	<mat-dialog-content>
		<form #form="ngForm" novalidate>
			<div style="margin:16px 0;font-size: 15px;" fxLayout="column" (window:resize)="onResize()">
				<div style="padding:16px 0; color: #ffffff;letter-spacing: 0.1em;" translate>ユーザー名</div>
				<div style="color:#fdfdfd;font-size:16px;">{{content.username}}</div>
				<!--	<mat-form-field appearance="outline" floatLabel="always" fxFlex="100" class="text-field">
						<input #username="ngModel" [(ngModel)]="content.username" autocomplete="off" email matInput maxlength="255" minlength="3" name="username" placeholder="{{'メールアドレス' | translate}}" required type="email" style="color: #000000;font-size: 18px;">
						<mat-error *ngIf="username.errors?.['email'];"><span translate>有効なメールアドレスを入力してください</span></mat-error>
						<mat-error *ngIf="username.errors?.['required'];"><span translate>入力してください</span></mat-error>
						<mat-error *ngIf="username.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						<mat-error *ngIf="username.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
					</mat-form-field>　-->
				<div style="padding:16px 0; color: #fdfdfd;letter-spacing: 0.1em;">{{content.contentname}}</div>
				<div style="margin: 12px;color: #fdfdfd;">{{content.contentdescription}}</div>
				<mat-form-field appearance="outline" floatLabel="always" fxFlex="100" class="text-field">
					<textarea
						#autosize="cdkTextareaAutosize"
						#question="ngModel"
						[(ngModel)]="content.question"
						cdkAutosizeMaxRows="15"
						cdkAutosizeMinRows="10"
						cdkTextareaAutosize
						matInput
						maxlength="1000"
						name="question"
						placeholder=""
						required
						style="color: #000000;font-size: 18px;"
					></textarea>
					<mat-error *ngIf="question.errors?.['required'];"><span translate>内容をご入力ください。</span></mat-error>
					<mat-error *ngIf="question.errors?.['maxlength'];"><span translate>長すぎます。</span></mat-error>
				</mat-form-field>
			</div>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="0px" style="padding:16px 0;">
		<div fxFlex="50" fxLayoutAlign="space-between">
			<button *ngIf="content.hascancel" [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button fxFlex="120px" style="color: #F4F7F1; height: 50px;letter-spacing: 0.1em;font-weight: bold;font-size: 15px;"><span translate>キャンセル</span></button>
		</div>
		<div fxFlex="50" fxLayoutAlign="end">
			<button (click)="onAccept()" *ngIf="!(form.invalid || isProgress)" [disabled]="form.invalid || isProgress" color="primary" style="background-color:#99774a; color: #F4F7F1; height: 50px;letter-spacing: 0.1em;font-weight: bold;font-size: 15px;" mat-raised-button fxFlex="120px"><span translate>送信</span></button>
			<button *ngIf="(form.invalid || isProgress)" [disabled]="isProgress" cdkFocusInitial color="primary" mat-raised-button style="background-color:#99774a; color: #F4F7F1; height: 50px;letter-spacing: 0.1em;font-weight: bold;font-size: 15px;" fxFlex="120px"><span translate>送信</span></button>
		</div>
	</mat-dialog-actions>
</div>
